<div class="main-grid">
  <div class="capacities-container">

    <div class="capacities-heading">
      <h1>{{ 'layout.welcome.title' | translate }}</h1>
      <p>{{ 'layout.welcome.subtitle' | translate }}</p>
    </div>

    <div class="capacities-grid">
      <app-general-capacity
        *ngFor="let capacity of capacities; let i = index"
        [title]="capacity.title | translate"
        [description]="capacity.description | translate"
        [icon]="capacity.icon"
        [link]="capacity.link"
        [@fadeIn]="{value: '', params: {delay: i * 100}}"
      >
      </app-general-capacity>
    </div>
  </div>
</div>
